<template>
    <v-col class="py-1 mt-6" cols="12">
        <h2>Nouvelle demande de relevé d'intempéries</h2>
        <v-divider class="my-6" />
        <!-- <v-text-field v-model="form.city" dense rounded filled label="Nom du chantier"/> -->

        <v-autocomplete v-if="!prefill" v-model="model" :items="items" :loading="isLoading" filled :search-input.sync="search"
            hide-no-data hide-selected item-text="search_nom" return-object no-filter rounded
            :placeholder="$t('city_or_cp')" />
        
        <span class="ma-4 display-1" v-if="prefill">{{model.search_nom}}</span>
        <a  v-if="prefill" @click="prefill = false">
            Changer
        </a>

        
        <v-row>
            <v-col cols="12" lg="6">
                <v-text-field filled rounded dense type="date" label="Date de début" v-model="form.date_start" />
            </v-col>
            <v-col cols="12" lg="6">
                <v-text-field filled rounded dense type="date" label="Date de fin" v-model="form.date_end" />
            </v-col>
            <v-col cols="8" class="py-6" >
               <h3 class="font-weight-bold">Parametres Météorologiques</h3>
            </v-col>    
            <v-col cols="4" >
                <v-checkbox label="Définir des seuils (optionnel)" v-model="ceils_activated"></v-checkbox>
            </v-col>
        </v-row>


        <v-divider style="width:40%;"></v-divider>

        <v-col class="font-weight-bold" cols="12">
            Parametre habituels
        </v-col>

        <v-row>

            <v-col class="py-1" cols="8">
                <v-checkbox label="Temp-Min" v-model="form.params.temp_min"></v-checkbox>
            </v-col>
            <v-col class="py-1" cols="4" v-if="ceils_activated">
                <v-text-field type="number" :disabled="!form.params.temp_min" v-model="form.params.temp_min_ceil"
                    label="Inf. à">
                    <template v-slot:append-outer>
                        °C
                    </template>
                </v-text-field>
            </v-col>
        </v-row>

        <v-row>
            <v-col class="py-1" cols="8">
                <v-checkbox label="Pluie" v-model="form.params.rain"></v-checkbox>
            </v-col>
            <v-col class="py-1" cols="4" v-if="ceils_activated">
                <v-text-field type="number" :disabled="!form.params.rain" v-model="form.params.rain_ceil"
                    label="Sup. à">
                    <template v-slot:append-outer>
                        mm
                    </template>
                </v-text-field>
            </v-col>
        </v-row>

        <v-row>
            <v-col class="py-1" cols="8">
                <v-checkbox label="Vent" v-model="form.params.wind"></v-checkbox>
            </v-col>

            <v-col class="py-1" cols="4" v-if="ceils_activated">
                <v-text-field type="number" :disabled="!form.params.wind" v-model="form.params.wind_ceil"
                    label="Sup. à">
                    <template v-slot:append-outer>
                        km/h
                    </template>
                </v-text-field>
            </v-col>
        </v-row>

        
        <v-divider style="width:40%;"></v-divider>

        <v-col class="font-weight-bold" cols="12">
            Parametre optionels
        </v-col>


        <v-row>
            <v-col class="py-1" cols="8">
                <v-checkbox label="Temp-Max" v-model="form.params.temp_max"></v-checkbox>
            </v-col>
            <v-col class="py-1" cols="4" v-if="ceils_activated">
                <v-text-field type="number" :disabled="!form.params.temp_max" v-model="form.params.temp_max_ceil"
                    label="Sup. à">
                    <template v-slot:append-outer>
                        °C
                    </template>
                </v-text-field>
            </v-col>
        </v-row>


        <v-row>
            <v-col class="py-1" cols="8">
                <v-checkbox label="Neige" v-model="form.params.snow"></v-checkbox>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="py-1" cols="8">
                <v-checkbox label="Humidité" v-model="form.params.humidity"></v-checkbox>
            </v-col>
        </v-row>
        <v-col cols=12 class="pb-16 text-right">
            <v-btn color="primary" :disabled="isLoading" rounded @click="submitForm()">
                Soumettre le formulaire
            </v-btn>
        </v-col>
        <v-snackbar v-model="error" top color="error">
            Une erreur est survenue
        </v-snackbar>
        <v-snackbar v-model="success" top color="success">
            Votre demande a bien été prise en compte
        </v-snackbar>
    </v-col>
</template>
<script>

import api from "@/api";
import { mapState } from "vuex";
import moment from 'moment';

export default {
    name: "DocumentsNew",
    methods: {
    },
    computed: {
        items() {
            return this.entries.map((chunk) =>
                chunk.cp
                    ? {
                        ...chunk,
                        search_nom: `${chunk.nom} (${chunk.cp.slice(0, 2)}) ${chunk.iso}`,
                    }
                    : { ...chunk, search_nom: `${chunk.nom} ${chunk.iso}` }
            );
        },
        ...mapState(["user"]),
    },
    data: () => ({
        ceils_activated:false,
        form: {
            city: null,
            date_start: null,
            date_end: null,
            params: {
                temp_min: true,
                temp_min_ceil: 0,
                temp_max: false,
                temp_max_ceil: 32,
                wind: true,
                wind_ceil: 60,
                snow: false,
                rain: true,
                rain_ceil: 5,
                humidity: false
            }
        },
        search: null,
        isLoading: false,
        entries: [],
        prefill:false,
        model: null,
        loading: false,
        error: false,
        success: false,
    }),
    mounted() {
        if(this.$route.query.raw)
        {
            this.fillFormWithRawData();
        }
    },
    methods: {
        decodeHtml(html) {
            var txt = document.createElement("textarea");
            txt.innerHTML = html;
            return txt.value;
        },
        async fillFormWithRawData() {
            let raw_data = this.$route.query.raw
            this.prefill = true;
            let data = decodeURI(raw_data);
            console.log('data', data);
            data = JSON.parse(raw_data);
            this.form.date_start = moment(data[0].debut).format('YYYY-MM-DD');
            this.form.date_end = moment(data[0].fin).format('YYYY-MM-DD');
            this.form.params.temp_min = data[0].tmin;
            this.form.params.temp_max = data[0].tmax;
            this.form.params.wind = data[0].vent;
            this.form.params.snow = data[0].neige;
            this.form.params.rain = data[0].pluie;
            this.form.params.humidity = data[0].rhmax;
            this.form.params.temp_min_ceil = data[0].seuil_tmin;
            this.form.params.temp_max_ceil = data[0].seuil_tmax;
            this.form.params.wind_ceil = data[0].seuil_vent;
            this.form.params.rain_ceil = data[0].seuil_pluie;
            let getinfos = await api.cities.getinfos(data[0].geoname);
            let search = await api.cities.search(getinfos.name)
            console.log(search);
            let res = await api.cities.getinfos(data[0].geoname)


            this.model = {
                nom: res.name,
                geoname: data[0].geoname,
                cp: res.cp,
                iso: res.iso,
                search_nom: `${res.name}`
            }

            console.log(this.model);
    

        },
        async submitForm() {
            console.log('submit');
            try {
                const bddObj = {
                    id_user: this.user.id_user,
                    pluie: this.form.params.rain,
                    tmin: this.form.params.temp_min,
                    tmax: this.form.params.temp_max,
                    vent: this.form.params.wind,
                    neige: this.form.params.snow,
                    rhmax: this.form.params.humidity,
                    debut: this.form.date_start,
                    fin: this.form.date_end,
                    seuil_pluie: this.form.params.rain_ceil,
                    seuil_tmin: this.form.params.temp_min_ceil,
                    seuil_tmax: this.form.params.temp_max_ceil,
                    seuil_vent: this.form.params.wind_ceil,
                    geoname: this.model.geoname
                };
                this.isLoading = true
                await api.documents.post(bddObj);
                this.success = true;
            } catch (err) {
                this.error = true;
                console.log(err);
            }
            this.$router.push("/documents");
            this.isLoading = false

        }
    },
    watch: {
        search(val) {

            this.isLoading = true;

            // Lazily load input items
            api.cities
                .search(val)
                .then((res) => {
                    this.entries = res;
                    this.count = res.length;
                })
                .catch((err) => {
                    console.error(err);
                })
                .finally(() => (this.isLoading = false));
        },
    },
}
</script>